import React from 'react';

import { DisclaimerInfoFragment } from 'src/api';
import { Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { DisclaimerCreateForm } from './DisclaimerCreateForm';
import { DisclaimerUpdateForm } from './DisclaimerUpdateForm';

export const DisclaimerEditModal: React.FC = () => {
  const { closeModal, isOpen, args } = useModal<{
    employerId?: string;
    disclaimer: DisclaimerInfoFragment;
    disclaimersList: DisclaimerInfoFragment[];
  }>(ModalId.DisclaimerEdit);

  const [employerId, disclaimer, disclaimersList] = React.useMemo(
    () => [args?.employerId, args?.disclaimer, args?.disclaimersList],
    [args],
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title={disclaimer ? `Edit Employer Disclaimer` : 'Add new Employer Disclaimer'}
      dialogProps={{
        fullWidth: true,
        maxWidth: 'md',
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      {disclaimer ? (
        <DisclaimerUpdateForm
          disclaimer={disclaimer}
          closeModal={onCloseModal}
          disclaimersList={disclaimersList}
        />
      ) : (
        <DisclaimerCreateForm
          employerId={employerId}
          closeModal={onCloseModal}
          disclaimersList={disclaimersList}
        />
      )}
    </Modal>
  );
};
